import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import EditTask from './EditTask'
import AllTasks from './AllTasks'

const Tasks = ({ match, loggedIn }) => {
  if (!loggedIn) {
    return <Redirect to="/login" />
  }

  return (
    <Switch>
      <Route exact path={match.url + '/'} component={AllTasks} />
      <Route path={match.url + '/:task'} component={EditTask} />
    </Switch>
  )
}

const mapState = state => {
  return {
    loggedIn: !!state.data.get('user'),
  }
}

export default connect(mapState)(Tasks)



// WEBPACK FOOTER //
// ./src/Tasks/index.js